
export default resolveChains;

import hasOwnProp from 'utils/hasOwnProp';

/**
 * Discovers 'chains' within a bundle - e.g. `import { foo } from 'foo'`
   may be equivalent to `import { bar } from 'bar'`, if foo.js imports `bar`
   and re-exports it as `foo`. Where applicable, import/export specifiers
   are augmented with an `origin: { module, name }` property
 * @param {array} modules - the bundle's array of modules
 * @param {object} moduleLookup - modules indexed by their ID
 */
function resolveChains(modules, moduleLookup) {
	var chains = {};

	// First pass - resolving intra-module chains
	modules.forEach(function (mod) {
		var origin = {};

		mod.imports.forEach(function (x) {
			var imported = x.module;

			x.specifiers.forEach(function (s) {
				if (s.isBatch) {
					// tell that module that it needs to export an object full of getters
					imported._exportsNamespace = true;
					return; // TODO can batch imports be chained?
				}

				origin[s.as] = s.name + '@' + imported.id;
			});
		});

		mod.exports.forEach(function (x) {
			if (!x.specifiers) return;

			x.specifiers.forEach(function (s) {
				if (hasOwnProp.call(origin, s.name)) {
					chains[s.as + '@' + mod.id] = origin[s.name];
				} else if (s.as !== s.name) {
					chains[s.as + '@' + mod.id] = s.name + '@' + mod.id;
				}
			});
		});
	});

	// Second pass - assigning origins to specifiers
	modules.forEach(function (mod) {
		mod.imports.forEach(function (x) {
			var imported = x.module;

			x.specifiers.forEach(function (s) {
				if (s.isBatch) {
					return; // TODO can batch imports be chained?
				}

				setOrigin(s, s.name + '@' + imported.id, chains, moduleLookup);
			});
		});

		mod.exports.forEach(function (x) {
			if (!x.specifiers) return;

			x.specifiers.forEach(function (s) {
				setOrigin(s, s.as + '@' + mod.id, chains, moduleLookup);
			});
		});
	});
}

function setOrigin(specifier, hash, chains, moduleLookup) {
	var isChained = undefined;

	while (hasOwnProp.call(chains, hash)) {
		hash = chains[hash];
		isChained = true;
	}

	if (isChained) {
		var _hash$split = hash.split('@');

		var _name = _hash$split[0];
		var moduleId = _hash$split[1];

		specifier.origin = { module: moduleLookup[moduleId], name: _name };
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/utils/resolveChains.js.01-babel.map